var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1074 27.5521C17.1074 20.6457 22.7062 15.0469 29.6127 15.0469C36.5191 15.0469 42.1179 20.6457 42.1179 27.5521V40.6574H17.1074V27.5521Z",
    fill: "white",
    stroke: "#212121",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41.9996C12 40.6741 13.0745 39.5996 14.4 39.5996H45.6C46.9255 39.5996 48 40.6741 48 41.9996C48 43.3251 46.9255 44.3996 45.6 44.3996H14.4C13.0745 44.3996 12 43.3251 12 41.9996Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 48.7102C32.6512 48.7102 34.8002 46.5611 34.8002 43.9102H25.2002C25.2002 46.5611 27.3492 48.7102 30.0002 48.7102Z",
    stroke: "#212121",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.613,
    cy: 12.9635,
    r: 1.56316,
    fill: "#212121",
    stroke: "#212121",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.731,
    cy: 13.731,
    r: 1.13143,
    stroke: "#212121",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.0002,
    cy: 32.3996,
    r: 7.8,
    fill: "white",
    stroke: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1006 28.4996C41.1006 28.0026 41.5035 27.5996 42.0006 27.5996V27.5996C42.4976 27.5996 42.9006 28.0026 42.9006 28.4996V32.0996C42.9006 32.5967 42.4976 32.9996 42.0006 32.9996V32.9996C41.5035 32.9996 41.1006 32.5967 41.1006 32.0996V28.4996Z",
    stroke: "#212121",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1006 36.2992C41.1006 36.7963 41.5035 37.1992 42.0006 37.1992V37.1992C42.4976 37.1992 42.9006 36.7963 42.9006 36.2992V36.2992C42.9006 35.8022 42.4976 35.3992 42.0006 35.3992V35.3992C41.5035 35.3992 41.1006 35.8022 41.1006 36.2992V36.2992Z",
    stroke: "#212121",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9681 20.9684L13.96 21.0109C13.8711 21.4772 14.1733 21.9284 14.6383 22.0239V22.0239C15.1128 22.1214 15.5753 21.8117 15.666 21.3358L15.6688 21.3212V21.3212C15.6689 21.3206 15.669 21.3201 15.6691 21.3195C15.6692 21.3191 15.6693 21.3186 15.6694 21.3181C15.6702 21.314 15.672 21.3058 15.6747 21.2936C15.6801 21.2692 15.6894 21.2291 15.7033 21.1749C15.7311 21.0665 15.7771 20.9024 15.847 20.6955C15.987 20.2811 16.2212 19.6998 16.5929 19.0536C17.3342 17.765 18.6187 16.2227 20.8074 15.2126V15.2126C21.2472 15.0096 21.4481 14.4923 21.2575 14.047L21.2388 14.0035C21.0508 13.5641 20.537 13.3666 20.103 13.5669V13.5669C17.5224 14.7579 15.9887 16.5922 15.104 18.1301C14.6628 18.8971 14.3821 19.5914 14.2105 20.0993C14.1246 20.3536 14.0656 20.5623 14.0274 20.7115C14.0082 20.7861 13.9942 20.846 13.9846 20.8893C13.9798 20.911 13.9761 20.9286 13.9734 20.9418L13.97 20.9584L13.9689 20.9642L13.9684 20.9665L13.9682 20.9675",
    stroke: "#212121",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAlert);
export default __webpack_public_path__ + "static/media/NotificationAlert.7fc3374a8ada5a7ebf2b253c21bf3b47.svg";
export { ForwardRef as ReactComponent };